import type { ReactNode } from 'react';

import classes from './ContentSection.module.css';

export const ContentSection = ({ children }: { children: ReactNode | ReactNode[] }) => (
    <div className={classes.contentSection}>{children}</div>
);
